var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._g({staticClass:"clear-filters pl-2 ml-3",attrs:{"text":"","small":""}},_vm.$listeners),[_c('v-icon',{staticClass:"mr-1",attrs:{"small":""}},[_vm._v("close")]),_vm._v(" Clear filters ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }